import api from "./api";

export const appPublicService = {
  getAppLinks: () => api.get("/app/links"),
};

